import React, { Fragment, useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  Card
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { Form, Link, useGetOne, useNotify } from 'react-admin';
import MobileStagger from './MobileStagger';
import { CenterDivider } from './CenterDivider';
import { useNavigate } from 'react-router-dom';
import { AuthenType, EmployeeRoles } from '../../constants/index';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { getSubmerchantInfo } from '../../services/SubMerchant';
import { getMerchantName } from '../../services/Merchant';
import { generateQRCode, updateProfile } from '../../services/Employee';
import FontSize from '../layout/FontSize';
import Color from '../layout/color/Color';




const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid #ccc',
  fontWeight: '500',
  textAlign: 'center',
  color: Color.Button,
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};
export const EditProfile = (props) => {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const isXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const notify = useNotify();
  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState({
    fullname: '',
    authentype: 1,
  });
  const { data, isLoading, refetch } = useGetOne('Employee', {});
  const [finishedLoading, setFinishedLoading] = useState(true);
  const [qrCode, setQrCode] = useState('');
  const [merchantData, setMerchantData] = useState({
    merchantName: '',
    submerchantName: '',
  });

  useEffect(() => {
    if (localStorage.getItem('userToken') === null) {
      navigate('/#/login', { replace: true });
    }
  });

  useEffect(() => {
    const getData = async (submerchantID) => {
      const submerchantInfo = await getSubmerchantInfo(submerchantID);
      const merchantName = await getMerchantName(
        parseInt(submerchantInfo.merchantID)
      );

      setMerchantData({
        merchantName: merchantName,
        submerchantName: submerchantInfo.name,
      });
      setEmployeeData({
        fullname: data.fullname,
        authentype: data.authentype,
      });
      setFinishedLoading(true);
    };

    if (!isLoading) getData(data.SubMerchant.id);

    if (!isLoading && data.authentype === 2) {
      generateQRCode()
        .then((res) => setQrCode(res.imageBase))
        .catch((err) => {
          console.log(err);
        });
    } else {
      setQrCode(null);
    }
  }, [isLoading, data]);

  const updateEmployee = () => {
    if (
      employeeData.fullname !== data.fullname ||
      employeeData.authentype !== data.authentype
    ) {
      updateProfile(data.id, employeeData.fullname, employeeData.authentype)
        .then((res) => {
          notify('Update profiles successfully!', {
            type: 'success',
          });
          refetch();
        })
        .catch((err) => {
          notify(err.message, {
            type: 'error',
          });
        });
    }
  };
  if (isLoading || !finishedLoading) return 'Loading...';

  return (
    <Fragment>
      <Card
        sx={{
          ml: '8px',
          mr: '8px',
          my: '30px'
        }}
      >
        <Form>
          <Grid
            container
            sx={{ fontSize: '12px', display: 'flex', justifyContent: 'space-between', py: 2, pr: 2 }}
          >
            <Grid sx={{ textAlign: 'left' }} item xs={12} md={6}>
              <Button
                endIcon={<ManageAccountsIcon sx={{ color: Color.Main }} />}
                sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
                size="medium"
              >
                <Typography variant="h3">Edit Profile</Typography>
              </Button>
            </Grid>
            <Grid item xs={12} md={6}
              align="right"
            >
              <Link to="/change-password">
                {isSm ? null : (
                  <Button
                    variant="outlined"
                    size="medium"
                    startIcon={<Edit />}
                    sx={backButton}
                  >
                    Change Password
                  </Button>
                )}
              </Link>
            </Grid>
          </Grid>
          <Divider sx={{ width: '100%', mb: 6 }} />
          <Grid container spacing={2} mt="3rem">
            <Grid item xs={12}>
              <Stack direction="column" spacing={1} pl={isXs ? "10%" : "12%"}>
                <Typography variant="h4" display="inline">
                  Merchant:{' '}
                  <Typography variant="h4" fontWeight="bold" display="inline">
                    {merchantData.merchantName}
                  </Typography>
                </Typography>
                <Typography variant="h4" display="inline">
                  Submerchant:{' '}
                  <Typography variant="h4" fontWeight="bold" display="inline">
                    {merchantData.submerchantName}
                  </Typography>
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} pb="20px">
              <CenterDivider />
            </Grid>
            <Grid
              item
              container
              spacing={3}
              md={qrCode ? 9 : 12}
              sm={qrCode ? 12 : 0}
            >
              <Grid
                item
                container
                xs={12}
                ml="10%"
                mr="10%"
                justifyContent="space-between"
              >
                <Grid item sm={12} md={5} width="100%">
                  <TextField
                    value={employeeData.fullname}
                    variant="outlined"
                    label="Fullname"
                    fullWidth
                    required
                    onChange={(e) =>
                      setEmployeeData({
                        ...employeeData,
                        fullname: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item sm={12} md={5} width="100%" pt={isSm ? '1rem' : '0'}>
                  <TextField
                    defaultValue={data.address}
                    variant="outlined"
                    label="Address"
                    fullWidth
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid
                item
                container
                xs={12}
                ml="10%"
                mr="10%"
                justifyContent="space-between"
              >
                <Grid item sm={12} md={5} width="100%">
                  <TextField
                    variant="outlined"
                    label="Phone number"
                    defaultValue={data.phone}
                    fullWidth
                    required
                    disabled
                  />
                </Grid>
                <Grid item sm={12} md={5} width="100%" pt={isSm ? '1rem' : '0'}>
                  <TextField
                    variant="outlined"
                    label="Email"
                    defaultValue={data.email}
                    fullWidth
                    required
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid
                item
                container
                xs={12}
                ml="10%"
                mr="10%"
                justifyContent="space-between"
              >
                <Grid item sm={12} md={5} width="100%">
                  <TextField
                    variant="outlined"
                    label="Role"
                    defaultValue={data.role}
                    select
                    fullWidth
                    required
                    disabled
                  >
                    {EmployeeRoles.map((role) => (
                      <MenuItem key={role.value} value={role.value}>
                        {role.roleName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={5} sm={12} width="100%" pt={isSm ? '1rem' : '0'}>
                  <TextField
                    value={employeeData.authentype}
                    fullWidth
                    select
                    variant="outlined"
                    label="AuthenType"
                    onChange={(e) => {
                      setEmployeeData({
                        ...employeeData,
                        authentype: e.target.value,
                      });
                    }}
                  >
                    {AuthenType.map((type) => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.display}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={qrCode ? 3 : 0} sm={qrCode ? 3 : 0} width="100%">
              {qrCode ? (
                <Grid
                  item
                  container
                  md={12}
                  xs="auto"
                  mr={isSm ? '0px' : '20%'}
                >
                  <Grid
                    item
                    xs={12}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="body2">
                      Authentication QR code
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                  >
                    <img alt="" src={qrCode} width="190px" height="auto" style={{ border: '1px solid #ccc' }} />
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
            <Grid
              item
              container
              xs={12}
              sx={{ mb: 3 }}
              ml="7%"
              mr="7%"
              mt="1rem"
              justifyContent="flex-end"
            >
              <Button
                size="medium"
                type="submit"
                onClick={updateEmployee}
                sx={saveButton}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Card>
      {isSm ? <MobileStagger /> : null}
    </Fragment>
  );
};
